import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiService } from "./base/api.service";
import { UserNotificationDto } from "../dtos/user-notification.dto";
import { UserNotificationFilterDto } from "../dtos/user-notification.filter.dto";

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {

    private readonly baseUrl = 'notifications/';

    public onChangePolPrice: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);

    constructor(private apiService: ApiService) { }

    getByFilter(model: UserNotificationFilterDto): Observable<UserNotificationDto[]> {
        return this.apiService.post<UserNotificationDto[]>(this.baseUrl + 'filter', model);
    }

    setLastRead(lastReadNotificationId: number): Observable<void> {
        return this.apiService.put(this.baseUrl + 'set-last-read?lastReadNotificationId=' + lastReadNotificationId, {});
    }
}